import _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { USER_TYPE_CLIENT } from 'src/app/models/usersTypes.model';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    isClient: boolean = false;

    tagVersion: string = '1.9.15';

    get nowYear(): number {
        return new Date().getFullYear();
    }

    get environment() {
        return environment;
    }

    constructor(protected auth: AuthService) {
    }

    ngOnInit(): void {
        this.auth.onAuthenticated.subscribe(async u => {
            if (u && u.attributes_name) {
                if (u.attributes_name.includes(USER_TYPE_CLIENT)) {
                    this.isClient = true;
                }
            }
        });

        this.getFileData();
    }

    getFileData(): void {
        fetch('../../../assets/last-tags.txt')
            .then(response => response.blob())  // Convertir la réponse en Blob
            .then(blob => { // Obtenez le nom du fichier si nécessaire

                const fileReader = new FileReader();

                fileReader.onerror = (event: any) => {
                    console.error(event.target.error);
                };
                fileReader.onload = (event: any) => {
                    const fileContent = event.target.result;

                    if (fileContent && fileContent.length > 0) {
                        const lines = fileContent.split('\n');

                        const prefix = environment.type === 'prod' ? 'serv-intern-' : 'staging-';

                        for (const line of lines) {
                            if (line.startsWith(prefix)) {
                                this.tagVersion = line.replace(prefix, '');
                                break;
                            }
                        }
                    }
                };

                const file = new File([blob], 'last-tags', { type: blob.type });
                fileReader.readAsText(file);
            });
    }
}
